import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import logger from "./utils/logger";

// Globally disable browser autocomplete on all inputs
document.addEventListener("focusin", (e) => {
  if (e.target?.tagName === "INPUT" && !e.target.hasAttribute("data-ac-set")) {
    e.target.setAttribute("autocomplete", "off");
    e.target.setAttribute("data-ac-set", "1");
  }
}, true);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then(
      (registration) => {
        logger.info("ServiceWorker registration successful with scope: ", registration.scope);
      },
      (error) => {
        logger.info("ServiceWorker registration failed: ", error);
      }
    );
  });
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
